class DataLoader {
    constructor(config) {
        this.targetElement = $(`#${config.targetElementId}`) ?? $(`.${config.targetElementClass}`);
        this.url = config.url;
        this.spinner = $(`#spinner-${config.targetElementId}`) ?? $(`#spinner-${config.targetElementClass}`);
        this.data = typeof config.data === 'function' ? config.data : () => { };
        this.addFunction = typeof config.addFunction === 'function' ? config.addFunction : () => { };
        this.getFormData = typeof config.getFormData == 'string' ? () => this.getFormDataBySelector(config.getFormData) :
            (typeof config.getFormData === 'function' ? config.getFormData : () => { });
        this.modal = (config.modal || false) ? '.modal.show' : 'body';
        this.global = (config.global || false);
        this.init();
    }

    async init() {
        try {
            const response = await this.makeAjaxCall();
            this.handleSuccess(response);
            this.addFunction();
        } catch (error) {
            this.handleHttpError(error);
        } finally {
            this.hideSpinner();
        }
    }

    async makeAjaxCall() {
        try {
            this.handleBeforeSend();
            const response = await $.ajax({
                dataType: "html",
                url: this.url || "/support/blank",
                data: this.getMergedData(),
                method: 'GET',
                global: this.global,
            });
            return response;
        } catch (error) {
            this.handleHttpError(error);

        }
    }

    handleHttpError(HttpRequest) {
        const contentType = HttpRequest.getResponseHeader("content-type") || "";

        if (contentType.includes("text/html")) {
            this.targetElement.html('Ocorreu uma falha na sua conexão');
            return showNotification("bottom", "center", "Ocorreu uma falha na sua conexão", "danger", this.modal);
        }

        const errors = JSON.parse(HttpRequest.responseText);

        if (HttpRequest.readyState === 4) {
            if (errors) {
                this.targetElement.html(errors.message || 'Nada encontrado');
                return errorAlertMessage(errors.errors || null, this.modal);
            }
            return showNotification("bottom", "center", "Ocorreu uma falha", "danger", this.modal);
        }

        if (HttpRequest.readyState === 0) {
            return showNotification("bottom", "center", "Falha na sua conexão", "danger", this.modal);
        }

        showNotification("bottom", "center", "Ocorreu uma falha na sua conexão", "danger", this.modal);
    }

    getMergedData() {
        return {
            ...this.data(),
            ...this.getFormData(),
        };
    }

    getFormDataBySelector(form) {
        var formData = {};
        $(form).serializeArray().forEach(function (field) {
            formData[field.name] = field.value;
        });
        return formData;
    }

    handleBeforeSend() {
        this.showSpinner();
        this.targetElement.stop(true, true).empty().hide(); // Clear and hide before loading new content
    }

    showSpinner() {
        this.spinner.stop(true, true).fadeIn(300); // Show spinner with faster fade-in
    }

    hideSpinner() {
        this.spinner.stop(true, true).fadeOut(300, () => {
            this.targetElement.fadeIn(300); // Show content after spinner fades out
        });
    }

    handleSuccess(response) {
        this.targetElement.html(response); // Updates the content and keeps it hidden until the spinner disappears
        this.initPopovers(); // Initializes the popovers
        this.initPlugins(); // Initializes plugins
    }

    initPopovers() {
        const popovers = this.targetElement.find('[data-bs-toggle="popover"]');
        popovers.popover(); // Reset the popovers

        popovers.on('show.bs.popover', function () { // Closes all popovers when opening a new one
            $('[data-bs-toggle="popover"]').not(this).popover('hide');
        });

        $(document).off('click.popover').on('click.popover', (e) => { // Closes the popover when clicking outside of it
            const $target = $(e.target);
            if (!$target.closest('.popover').length && !$target.closest('[data-bs-toggle="popover"]').length) {
                $('[data-bs-toggle="popover"]').popover('hide');
            }
        });
    }

    initPlugins() {
        if ($(".slpicker").length) {
            $(".slpicker")
                .selectpicker({
                    noneSelectedText: 'Nenhum item selecionado',
                    noneResultsText: 'Nenhum resultado encontrado para: {0}'
                })
                .selectpicker("refresh");
        }
        handleToggle();
    }
}

window.startDataLoader = function (config = {}) {
    new DataLoader(config);
}

window.handleModalDecrypted = function (config) {
    class handleModalDecrypted {
        constructor(config) {
            this.trigger = document.querySelector(`#${config.triggerSelector}`);
            this.modal = document.querySelector(`#${config.modalSelector}`);
            this.bodyModal = `${config.modalSelector}BodyModal`;
            this.contentData = this.initializeContent(config.content);
            this.init();
        }

        init() {
            if (this.trigger) {
                this.trigger.addEventListener("click", () => this.showModal());
                $(this.modal).on('hidden.bs.modal', () => this.clearContent());
            } else {
                console.error(`Trigger element not found for selector: #${config.triggerSelector}`);
            }
        }

        showModal() {
            this.clearContent(); // Limpa ao abrir o modal
            $(this.modal).modal('show');
            if (this.contentData) {
                this.startDataLoader();
            }
        }

        initializeContent(content) {
            if (content) {
                return {
                    ...content,
                    targetElementId: content.targetElementId || this.bodyModal
                };
            }
            return null;
        }

        startDataLoader() {
            new DataLoader(this.contentData);
        }

        clearContent() {
            $('[data-notify="container"]').remove();
            if (this.contentData && this.contentData.targetElementId) {
                $(`#${this.contentData.targetElementId}`).html('');
            }
        }
    }
    new handleModalDecrypted(config);
};

window.handleModalCarousel = function (config) {
    class HandleModalCarousel {
        constructor(config) {
            this.trigger = $(`.${config.triggerSelector}`);
            this.modal = $(`.${config.modalSelector}`);
            this.bodyModal = `${config.modalSelector}BodyModal`;
            this.contentData = this.initializeContent(config.content);
            this.init();
        }

        init() {
            if ($(`.${config.triggerSelector}`)) {
                $(document).on('click', `.${config.triggerSelector}`, this.showModal.bind(this));
                $(this.modal).on('hidden.bs.modal', () => this.clearContent());
            }
        }

        showModal(event) {
            this.clearContent();
            $(this.modal).modal('show');
            if (this.contentData) {
                this.contentData = {
                    ...this.contentData,
                    data: function () {
                        return {
                            id: $(event.target).attr('data-id'),
                        }
                    },
                };
                this.startDataLoader();
            }
        }

        initializeContent(content) {
            if (content) {
                return {
                    ...content,
                    targetElementId: content.targetElementId || this.bodyModal
                };
            }
            return null;
        }

        startDataLoader() {
            new DataLoader(this.contentData);
        }

        clearContent() {
            $('[data-notify="container"]').remove();
            if (this.contentData && this.contentData.targetElementId) {
                $(`#${this.contentData.targetElementId}`).html('');
            }
        }
    }
    new HandleModalCarousel(config);
};

window.handleModal = function (config) {
    class SelectorModal {
        constructor(rawSelector) {
            this._selector = this._sanitize(rawSelector);
        }

        _sanitize(selector) {
            return typeof selector === 'string' ? selector.trim() : '';
        }

        get value() {
            return this._selector;
        }

        get stripped() {
            return this._selector.replace(/^\.|#/, '');
        }

        get bodyId() {
            return `${this.stripped}BodyModal`;
        }

        get bodySelector() {
            return `#${this.bodyId}`;
        }
    }

    class ModalConfigDTO {
        constructor({ triggerSelector, modalSelector, data, timer, closeModalOrClickOut, modal }) {
            this._trigger = new SelectorModal(triggerSelector);
            this._modal = new SelectorModal(modalSelector);
            this._dataFn = this._asFunction(data, () => ({}));
            this._modalOptionsFn = this._asFunction(modal, () => ({}));
            this._closeCallback = this._asFunction(closeModalOrClickOut, () => { });
            this._timer = parseInt(timer, 10) || 0;

            this._validate();
        }

        _asFunction(value, fallback) {
            return typeof value === 'function' ? value : fallback;
        }

        _validate() {
            this._ensure(this._trigger.value, 'triggerSelector');
            this._ensure(this._modal.value, 'modalSelector');
        }

        _ensure(value, field) {
            if (!value) throw new Error(`${field} is required.`);
        }

        get triggerSelector() {
            return this._trigger.value;
        }

        get modalSelector() {
            return this._modal.value;
        }

        get modalBodySelector() {
            return this._modal.bodySelector;
        }

        get pollingTime() {
            return this._timer;
        }

        getBodyId() {
            return this._modal.bodyId;
        }

        getData(button) {
            return this._dataFn(button);
        }

        getOptions(button, modal) {
            return this._modalOptionsFn(button, modal);
        }

        runCloseCallback(modalEvent) {
            return this._closeCallback(modalEvent);
        }
    }

    class ModalHandler {
        constructor(config) {
            this._config = config;
            this._modal = $(config.modalSelector);
            this._body = $(config.modalBodySelector);
            this._intervalId = null;
            this._lastTrigger = null;

            this._bindEvents();
        }

        _bindEvents() {
            $(document).on('click', this._config.triggerSelector, this._onOpen.bind(this));
            this._modal.on('hidden.bs.modal', this._onClose.bind(this));
        }

        _onOpen(event) {
            this._lastTrigger = event.currentTarget;
            this._clearModal();
            this._showModal();
            this._updateHeader();
            this._startPolling();
        }

        _onClose(event) {
            this._stopPolling();
            this._clearModal();
            this._config.runCloseCallback(event);
        }

        _showModal() {
            this._modal.modal({ backdrop: 'static', keyboard: false });
            this._modal.modal('show');
        }

        _updateHeader() {
            const options = this._config.getOptions(this._lastTrigger, this._modal);

            this._setTitle(options.title);
            this._setIcon(options.icone);
        }

        _setTitle(title) {
            if (title) {
                this._modal.find('.title_modal').html(title || '');
            }
        }

        _setIcon(iconClass) {
            if (iconClass) {
                const baseClass = 'modal_icon fa';
                const icon = this._modal.find('.modal_icon');
                icon.removeClass().addClass(iconClass ? `${baseClass} ${iconClass}` : baseClass);
            }
        }

        _clearModal() {
            $('[data-notify="container"]').remove();
            this._body.empty();
            this._setTitle('');
            this._setIcon(null);
        }

        _loadContent() {
            const { action, data } = this._config.getData(this._lastTrigger);

            new DataLoader({
                ...action,
                data: () => data,
                targetElementId: this._config.getBodyId(),
                global: false,
            });
        }

        _startPolling() {
            this._loadContent();
            this._stopPolling();

            if (this._config.pollingTime <= 0) return;

            this._intervalId = setInterval(() => {
                if (this._modal.hasClass('show')) {
                    this._loadContent();
                }
            }, this._config.pollingTime * 1000);
        }

        _stopPolling() {
            if (!this._intervalId) return;

            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    }

    const modalConfigDTO = new ModalConfigDTO(config);
    new ModalHandler(modalConfigDTO);
};

class Select2Creatable {
    constructor(dto) {
        this.dto = dto;
        this.selectElement = this.dto.selectElement;
        this.activeSelect = null;
        this.init();
    }
    init() {
        if (this.dto.elementExists == false) {
            return;
        }
        this.initializeSelect2();
        this.listenForOpen();
        this.initializeModal();
    }

    initializeSelect2() {
        this.select().select2(this.select2Config());
    }

    listenForOpen() {
        this.select().on('select2:open', (event) => {
            this.activeSelect = $(event.target);

            // Remove botões antigos antes de adicionar novamente
            this.resultsContainer().siblings('.add-new-button, .go-to-button').remove();

            const addButton = this.createTriggerButton();
            const goButton = this.createGoButton();

            this.placeTriggerButton(addButton);
            if (goButton) this.placeTriggerButton(goButton);

            this.attachCloseEvent(addButton);
        });
    }

    createGoButton() {
        if (!this.dto.triggerLabelGo || !this.dto.triggerGoUrl) return null;

        return $('<a>', {
            class: 'go-to-button',
            text: this.dto.triggerLabelGo,
            css: this.triggerStyle(),
            href: this.dto.triggerGoUrl,
            target: '_blank',
            rel: 'noopener noreferrer', // Recomendado por segurança
        });
    }


    initializeModal() {
        handleModal({
            ...this.dto.handleModal,
        });
    }

    triggerButtonIsPresent() {
        const $results = this.resultsContainer();
        return (
            $results.next(`.add-new-button`).length > 0 ||
            $results.next(`.go-to-button`).length > 0
        );
    }

    createTriggerButton() {
        return $('<div>', {
            class: `add-new-button ${this.triggerClassFromHandleModal()}`,
            text: this.dto.triggerLabel,
            css: this.triggerStyle(),
            'data-action-url-modal': this.getDynamicActionUrl(),
        });
    }

    getDynamicActionUrl() {
        if (this.activeSelect) {
            const url = this.activeSelect.data('action-url-modal');
            return typeof url === 'string' ? url.trim() : '';
        }
        return '';
    }

    triggerClassFromHandleModal() {
        return this.dto.handleModal.triggerSelector.replace(/^\./, '');
    }

    placeTriggerButton(button) {
        this.resultsContainer().after(button);
    }

    attachCloseEvent(button) {
        $(button).on('click', () => this.closeSelect());
    }

    closeSelect() {
        this.select().select2('close');
    }

    select2Config() {
        return {
            placeholder: 'Selecione uma opção',
            language: {
                noResults: () => 'Resultado não encontrado',
            },
            dropdownParent: $('body'),
        };
    }

    triggerStyle() {
        return {
            padding: '8px',
            textAlign: 'center',
            cursor: 'pointer',
            color: 'blue',
            display: 'block',
            // width: 'resolve',
            width: '100%',

            // style: 'width: 100%;',
        };
    }

    select() {
        return this.dto.selectElement;
    }

    resultsContainer() {
        return $('.select2-results');
    }
}

class Select2CreatableDTO {
    constructor({
        selectSelector,
        triggerLabel,
        triggerLabelGo,
        triggerGoUrl,
        handleModal
    }) {
        this.selectSelector = this.cleanString(selectSelector);
        this.triggerLabel = this.cleanString(triggerLabel);
        this.triggerLabelGo = this.cleanString(triggerLabelGo);
        this.triggerGoUrl = this.cleanString(triggerGoUrl);
        this.handleModal = this.cleanHandleModal(handleModal);
        this.elementExists = true;

        this.validate();
    }

    validate() {
        this.ensureRequired(this.selectSelector, 'selectSelector');
        this.ensureRequired(this.triggerLabel, 'triggerLabel');
        this.ensureRequired(this.handleModal.triggerSelector, 'handleModal.triggerSelector');
        this.ensureRequired(this.handleModal.modalSelector, 'handleModal.modalSelector');
        this.ensureRequired(this.handleModal.data, 'handleModal.data');
        this.ensureElementExists();
    }

    ensureRequired(value, field) {
        if (!value) throw new Error(`${field} is required`);
    }

    ensureElementExists() {
        if (this.selectElement.length === 0) {
            // console.warn(`[select2Creatable] Element not found for selector: "${this.selectSelector}"`);
            this.elementExists = false;
        } else {
            this.elementExists = true;
        }
    }

    cleanString(value) {
        return typeof value === 'string' ? value.trim() : '';
    }

    cleanHandleModal(value) {
        return typeof value === 'object' && value !== null
            ? {
                triggerSelector: this.cleanString(value.triggerSelector),
                modalSelector: this.cleanString(value.modalSelector),
                data: value.data,
            }
            : { triggerSelector: '', modalSelector: '', data: () => ({}) };
    }

    get selectElement() {
        return $(this.selectSelector);
    }
}

window.select2Creatable = function (config) {
    const dto = new Select2CreatableDTO(config);
    new Select2Creatable(dto);
};
